angular.module('accessWebClient')
    .directive('accNotarizationInProgressIconClipPath', function () {
        return {
            replace: true,
            template: '<acc-svg-definition>'+
                '<clipPath clipPathUnits="objectBoundingBox" class="ng-scope" id="notarizationInProgress">' +
                    '<path d="M0.4,0 L0.4,0.5 L1,1 L0,1 L0,0 Z"></path>' +
                '</clipPath>' +
            '</acc-svg-definition>'
        };
    })
